import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import { Typography, Avatar, Input, DatePicker, Modal, Button, Menu, Col, Row, message, ConfigProvider, Checkbox, Tab, Carousel, Space, Tag,QRCode } from "antd";
import { Link, useParams, useNavigate, json } from "react-router-dom";
import { } from '@ant-design/icons';
import { url, client_id } from "../../../../login/setting"
import Label_language from '../../../../language';
import BindLineId from "../../../../login/BindLineId";
import ProTableOT from "../../../../utility/ProTable_ot";
import { useEmergencyContact } from "../controllers/useEmergencyContact";
const label_language = Label_language.ems.children
const setParamsFilter = (obj) => {
    //拿掉值為空或是null 的東西
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
const EmergencyContactList = () => {
    const columns = [
        {
            title: '家長名稱',
            dataIndex: 'emergency_contact_name',
            key: 'emergency_contact_name',
        },
        {
            title: '電話',
            dataIndex: 'emergency_contact_phone_number',
            key: 'emergency_contact_phone_number',
        },
        {
            title: '孩子姓名',
            disabled: true,
            key: 'student_data',
            sorter: false,
            render: (text, record, index) => {
                let student_data = record?.student_data
                if (Array.isArray(student_data)) {
                    return <Space
                        direction="vertical"
                    >
                        {
                            student_data.map((value) => {
                                return value?.name
                            })
                        }
                    </Space>
                }
                else {
                    return "-"
                }
            },
        },
        {
            title: '綁定狀態',
            sorter: false,
            disabled: true,
            key: 'binding_status',
            render: (text, record, index) => {
                let binding_status = record?.binding_status
                let binding_status_notify = record?.binding_status_notify
                let node = []
                if (!!binding_status) {
                    node.push(<Tag color="green">
                        已綁定Line
                    </Tag>)
                }
                else {
                    node.push(<Tag color="red">
                        未綁定Line
                    </Tag>)
                }
                if (!!binding_status_notify) {
                    node.push(<Tag color="green">
                        已綁定Line通知
                    </Tag>)
                }
                else {
                    node.push(<Tag color="red">
                        未綁定Line通知
                    </Tag>)
                }
                return <Space>{node.map(item => item)}</Space>
            },
        },
        {
            title: '綁定家長',
            key: "user_id",
            sorter: false,
            disabled: true,
            render: (text, record, index) => {
                return (<>
                    <BindQRcode
                        key={`${index}`}
                        userId={record?.user_id}
                        onSuccess={() => actionRef.current.reload()}
                    />

                </>)
            },
        },
        // {
        //     title: '綁定',
        //     sorter: false,
        //     disabled: true,

        //     render: (text, record, index) => {
        //         const punch_type_id = 1
        //         const value = (record?.student_id)
        //         const state = encodeURIComponent(JSON.stringify({
        //             service: `/cramSchool/punchInAndOut/ChildrenBinding/${value}`,
        //             state: Date.now()
        //         }))
        //         let classInfo = ``
        //         if (!!record?.student_class) {
        //             record?.student_class.forEach(element => {
        //                 classInfo += `${element?.grade_class_name} `
        //             })
        //         }

        //         return (<>
        //             <BindStudentParentQRcode
        //                 buttomInfo={<Space>{record?.name} {classInfo} </Space>}
        //                 value={
        //                     'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=' +
        //                     client_id + '&redirect_uri=' + url + '&state=' + state +
        //                     '&scope=profile%20openid&nonce=' + value
        //                 }
        //             />

        //         </>)
        //     },
        // },

        


    ];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20)
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)
    const {
        getEmergencyContactData,
        emergencyContactData
    } = useEmergencyContact({
        onBefore: () => { },
        onFinish: ({ axiosMode, status }) => {
            console.log({ axiosMode, status })
        }

    })
    useEffect(() => {
        checkAll()
    }, [])
    return (
        <Row>
            <Col span={24}>
                <ProTableOT
                    actionRef={actionRef}
                    headerTitle={<Space>

                    </Space>}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    rowKey={'news_id'}
                    selections={{
                        // onChange: (index_, data_) => set_data(data_)
                    }}
                    toolBarRender={() => [

                    ]}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    manage_columns={false}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        setPageSize(params?.pageSize ?? 20)

                        return getEmergencyContactData(newParams)
                    }}
                    pageSize={pageSize}

                   

                    scroll={{
                        x: "max-content"
                    }}

                />
            </Col>
        </Row>

    );
};
export default EmergencyContactList;
const BindStudentParentQRcode = ({
    value = null,
    userId = null,
    buttomInfo = <></>,
    onSuccess = () => {

    }
}) => {
    const [show, setShow] = useState(false)
    return (
        <Space direction="vertical">
            <Button
                size="small"
                onClick={() => {
                    setShow(pre => !pre)
                }}>
                {show ? "隱藏" : "顯示"}
            </Button>

            {show && <Space direction="vertical">
                <BindLineId
                    userId={userId}
                />
                {buttomInfo}
            </Space>
            }
        </Space>
    )
}

const BindQRcode = ({
    onSuccess = () => {

    },
    userId
}) => {
    const [show, setShow] = useState(false)
    useEffect(() => {
        setShow(false)
    }, [userId])
    return (
        <Space direction="vertical">
            <Button
                size="small"
                onClick={() => {
                    setShow(pre => !pre)
                }}>
                {show ? "隱藏" : "顯示"}
            </Button>

            {show &&
                <BindLineId
                    userId={userId}
                    onSuccess={onSuccess}
                />}
        </Space>
    )
}
const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        let newOrders = Object.keys(sorter).map((key, index) => {
            if (sorter[key] === "descend") {
                return JSON.stringify({
                    column: key,
                    type: 'DESC'
                })
            }
            else {
                return JSON.stringify({
                    column: key,
                    type: 'ASC'
                })
            }

        })
        return newOrders
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}